import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon } from './Icon';
import css from './Button.module.css';

export type ButtonTone = 'primary' | 'neutral' | 'quiet' | 'danger';
export type ButtonSize = 'md' | 'lg';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  tone?: ButtonTone;
  size?: ButtonSize;
  icon?: string;
  /** Icon after the label (a "next" arrow). */
  iconAfter?: boolean;
  children?: ReactNode;
}

/** The one button of the kiosk: at least --target-min tall, so a finger always hits it. */
export function Button({ tone = 'neutral', size = 'md', icon, iconAfter = false, children, className, type = 'button', ...rest }: ButtonProps) {
  const glyph = icon ? <Icon name={icon} size={size === 'lg' ? 40 : 32} /> : null;
  return (
    <button type={type} className={[css.button, css[tone], css[size], className].filter(Boolean).join(' ')} {...rest}>
      {!iconAfter && glyph}
      {children !== undefined && <span className={css.label}>{children}</span>}
      {iconAfter && glyph}
    </button>
  );
}
